var UitkLayoutColumnCountMap = [[1, '1'], [2, '2'], [3, '3'], [4, '4'], [5, '5'], [6, '6'], [8, '8'], [12, '12']];
var UitkLayoutColumnCounts = new Map(UitkLayoutColumnCountMap);
var UitkLayoutColumnItemSpanMap = [['all', 'column-span-all']];
var UitkLayoutColumnItemSpans = new Map(UitkLayoutColumnItemSpanMap);
var UitkLayoutColumnItemBreakInsideMap = [['avoid', 'break-inside-avoid']];
var UitkLayoutColumnItemBreakInsides = new Map(UitkLayoutColumnItemBreakInsideMap);
var UitkLayoutColumnItemBreakBeforeMap = [['avoid', 'break-before-avoid']];
var UitkLayoutColumnItemBreakBefores = new Map(UitkLayoutColumnItemBreakBeforeMap);
var UitkLayoutColumnItemBreakAfterMap = [['avoid', 'break-after-avoid']];
var UitkLayoutColumnItemBreakAfters = new Map(UitkLayoutColumnItemBreakAfterMap);
export { UitkLayoutColumnCounts, UitkLayoutColumnItemBreakAfters, UitkLayoutColumnItemBreakBefores, UitkLayoutColumnItemBreakInsides, UitkLayoutColumnItemSpans };